import React from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import flow from 'lodash/flow';

import { validated } from 'components/util';
import { completeInfo } from 'schemas/auth_schemas';

import { Form } from 'common/components';

const CompleteInfoForm = ({
  errors = {},
  handleSubmit = () => {},
  handleValueChange = () => {},
  isLoading = false,
  isSubmitted = false,
  t = (k) => k,
  values = { name: '', lastname: '', password: '' },
}) => {
  return (
    <form onSubmit={handleSubmit} noValidate autoComplete="false">
      <div className="row">
        <div className="col-sm-6">
          <Form.FieldInput
            autoFocus={true}
            error={(isSubmitted && errors.name) || {}}
            handleChange={handleValueChange}
            inputSize={'lg'}
            iconLeft={'address-card-o'}
            name={'name'}
            placeholder={t('complete_info.fields.name')}
            value={values.name}
          />
        </div>

        <div className="col-sm-6">
          <Form.FieldInput
            error={(isSubmitted && errors.lastname) || {}}
            handleChange={handleValueChange}
            inputSize={'lg'}
            iconLeft={'address-card-o'}
            name={'lastname'}
            placeholder={t('complete_info.fields.lastname')}
            value={values.lastname}
          />
        </div>

        <div className="col-12">
          <Form.FieldInput
            error={(isSubmitted && errors.password) || {}}
            handleChange={handleValueChange}
            inputSize={'lg'}
            iconLeft={'lock'}
            name={'password'}
            errorPrefix={'login.password'}
            placeholder={t('complete_info.fields.password')}
            type={'password'}
            value={values.password}
          />
        </div>

        <div className="col-md-12">
          <Form.Button
            text={t('complete_info.fields.submit')}
            isLoading={isLoading}
            extraClassName={'btn-lg pull-right btn-md-block'}
          />
        </div>
      </div>
    </form>
  );
};

CompleteInfoForm.propTypes = {
  errors: PropTypes.object,
  isLoading: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  handleValueChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  values: PropTypes.shape({
    name: PropTypes.string.isRequired,
    lastname: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
  }).isRequired,
};

export default flow(translate(), validated(completeInfo))(CompleteInfoForm);



// WEBPACK FOOTER //
// src/modules/auth/components/form/CompleteInfoForm.js